import { useState, useEffect, useCallback, useContext, useRef } from "react";
import { ReactSession } from "react-client-session";
import Modal from "@mui/material/Modal";
import { getSuccessToast, getErrorToast } from "../../toast";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";

import EntriesDataContext from "../../context/EntriesDataContext";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { toast } from "react-toastify";
import {Autocomplete, TextField,  Box} from "@mui/material";

import "./ManualEntryTable.css";
import bin from "../../assets/bin.svg";
const ManualEntryTable = () => {
  const boxId = ReactSession.get("box_id_s");
  const { redirectId, setRedirectId } = useContext(EntriesDataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [medData, setMedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [batchNo, setBatchNo] = useState();
  const [quantity, setQuantity] = useState();
  const [expiryStatus, setExpiryStatus] = useState("");
  const [expStatVal, setExpStatVal] = useState("");

  const [materialDesc, setMaterialDesc] = useState();
  const [divName, setDivName] = useState();
  const [pack, setPack] = useState();
  const [materialNo, setMaterialNo] = useState();
  const [mfgDate, setMfgDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [mrp, setMrp] = useState();
  const [date, setDate] = useState();

  const [medId, setMedId] = useState();
  const [editState, setEditState] = useState(false);
  const [open, setOpen] = useState(false);
  const [searched, setSearched] = useState("");
  const [tableType, setTableType] = useState("groupBy");
  const [medicineType, setMedicineType] = useState("all");
  const [markBreakage, setMarkBreakage] = useState(false);
  const [disableCheckbox, setDisableCheckbox] = useState(false);

  const [ids, setIds] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const batchNoRef = useRef();
  const materialDescRef = useRef("");
  const packRef = useRef("");
  const materialNoRef = useRef("");
  const mfgDateRef = useRef("");
  const expiryDateRef = useRef("");
  const mrpRef = useRef("");
  const quantityRef = useRef();
  const dateRef = useRef("");
  const expiryStatusRef = useRef("");
  const checkedRef = useRef();

  const navigate = useNavigate();

  const columns = [
    {
      id: "batch_no",
      label: "Batch",
      minWidth: "10%",
    },
    {
      id: "material_desc",
      label: "Material Description",
      minWidth: "10%",
    },
    {
      id: "product_code",
      label: "Material Code",
      minWidth: "10%",
    },
    {
      id: "quantity",
      label: "Quantity",
      minWidth: "4%",
    },
    {
      id: "mrp",
      label: "MRP",
      minWidth: "6%",
    },
    {
      id: "expiry_status",
      label: "Expiry Status",
      minWidth: "8%",
    },
    {
      id: "breakage",
      label: "Breakage",
      minWidth: "4%",
    },
    {
      id: "mfg_date",
      label: "MFG Date",
      minWidth: "10%",
    },
    {
      id: "exp_date",
      label: "Expiry Date",
      minWidth: "10%",
    },

    {
      id: "date",
      label: "Date",
      minWidth: "8%",
    }
  ];

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  function removeAllElements(array, elem) {
    var index = array.indexOf(elem);
    while (index > -1) {
      array.splice(index, 1);
      index = array.indexOf(elem);
    }
  }

  const getBoxData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await axiosPrivate.get(`/dashboard/boxdetails/${boxId}/0`);
      setMedData(res.data.data);
      setRowData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectId]);

  useEffect(() => {
    getBoxData();
  }, [getBoxData]);

  useEffect(() => {
    if (searched.length >= 3) {
      const filteredData = rowData.filter((row) => {
        return row.medicine_master__batch_number
          .toLowerCase()
          .includes(searched.toLowerCase());
      });

      setMedData(filteredData);
    } else if (searched.length === 0) {
      let tempArr = JSON.parse(JSON.stringify(rowData));

      setMedData(tempArr);
    }
  }, [rowData, searched]);


  const confirmDelteHandler = () => {
    const medicineId = { box_medicine_data_master_id: medId };
    const headers = {
      "Content-Type": "application/json",
    };
    axiosPrivate
      .delete(
        "/data_entry/update_entry/",
        {
          data: medicineId,
        },
        headers
      )
      .then((res) => {
        if (res.status === 204) {
          toast.success("Entry deleted successfully", {
            theme: "colored",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setRedirectId((prev) => prev - 10);
          navigate("/scan");
          navigate("/manual-entry");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  const searchTableHandler = (e) => {
    setSearched(e.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const checkBoxHandler = (e) => {
    if (checkedRef.current.checked) {
      expiryStatusRef.current.value = "BREAKAGE";
    } else if (
      !checkedRef.current.checked &&
      expiryStatusRef.current.value === "BREAKAGE"
    ) {
      expiryStatusRef.current.value = expStatVal;
    } else {
    }
  };

  const changeTableHandler = (e) => {
    setTableType(e.target.value);

    if (e.target.value !== "groupBy") {
      let headerData = null;
      if (e.target.value === "medicine_master__batch_number") {
        headerData = `<thead>
          <tr >
            <th>Sr No.</th>
            <th>Batch Number</th>
            <th>Medicine Name</th>
            <th>Material Code</th>
            <th>Total Quantity</th>
            <th>Reason</th>
            <th>Expiry Date</th>
            <th>Quantity</th>
            <th>MRP</th>
            <th>Total MRP</th>
          </tr>
        </thead>`;
      } else {
        headerData = `<thead>
          <tr id="table-header-row"> >
            <th>Sr No.</th>
            <th>Medicine Name</th>
            <th>Material Code</th>
            <th>Total Quantity</th>
            <th>Reason</th>
            <th>Expiry Date</th>
            <th>Batch Number</th>
            <th>Quantity</th>
            <th>MRP</th>
            <th>Total MRP</th>
          </tr>
        </thead>`;
      }
      setIsLoading(true);

      axiosPrivate
        .get(`/dashboard/group_by/${boxId}?field_name=${e.target.value}`)
        .then((res) => {
          document.querySelector("#group_by_table_container").innerHTML =
            res.data;

          document.querySelector(".dataframe thead").remove();

          document
            .querySelector(".dataframe")
            .insertAdjacentHTML("afterbegin", headerData);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
  };

  const sortMedicineHandler = (e) => {
    setMedicineType(e.target.value);
    if (e.target.value === "all") {
      setIsLoading(true);
      axiosPrivate
        .get(`/dashboard/boxdetails/${boxId}/0`)
        .then((res) => {
          setMedData(res.data.data);
          setRowData(res.data.data);
          setRedirectId((prev) => prev - 1);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setIsLoading(false);
        });
    } else if (e.target.value === "sellable") {
      setIsLoading(true);

      let tempArr = rowData.filter(
        (row) =>
          row.goods_type === "SELLABLE" || row.goods_type === "SHORT EXPIRY"
      );

      setMedData(tempArr);

      setIsLoading(false);
    } else if (e.target.value === "expired") {
      setIsLoading(true);

      let tempArr = rowData.filter((row) => row.goods_type === "EXPIRED");
      setMedData(tempArr);

      setIsLoading(false);
    }
  };

  // => FOR SINGLE CHECKBOX
  const toggleBreakageHandler = async (e, id) => {
    let tempArr = JSON.parse(JSON.stringify(medData));

    if (e.target.checked) {
      setDisableCheckbox(true);

      const res = await axiosPrivate.put("/data_entry/to-breakage/", {
        checked: e.target.checked,
        ids: [id],
      });

      if (res.status === 200) {
        tempArr.map((row) => {
          if (row.box_medicine_data_master_id === id) {
            row.goods_type = "BREAKAGE";
          }
        });

        toast.success("Updated record successfully", {
          theme: "colored",
          position: "top-right",
          autoClose: 500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong!", {
          theme: "colored",
          position: "top-right",
          autoClose: 500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      setDisableCheckbox(false);

      const state = tempArr.every((row) => row.goods_type === "BREAKAGE");
      setMarkBreakage(state);

      setMedData(JSON.parse(JSON.stringify(tempArr)));
    } else {
      removeAllElements(ids, id);
      setDisableCheckbox(true);

      const data = rowData.filter(
        (row) => row.box_medicine_data_master_id === id
      );

      const goodsType = data[0]["goods_type"];

      const res = await axiosPrivate.put("/data_entry/to-breakage/", {
        checked: e.target.checked,
        ids: [id],
        status_arr: [goodsType],
      });

      if (res.status === 200) {
        tempArr.map((row) => {
          if (row.box_medicine_data_master_id === id) {
            row.goods_type = goodsType;
          }
        });

        toast.success("Updated record successfully", {
          theme: "colored",
          position: "top-right",
          autoClose: 500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong!", {
          theme: "colored",
          position: "top-right",
          autoClose: 500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      setDisableCheckbox(false);

      const state = tempArr.every((row) => row.goods_type === "BREAKAGE");
      setMarkBreakage(state);

      setMedData(JSON.parse(JSON.stringify(tempArr)));
    }
  };

  // => FOR ALL CHECKBOX
  const markBreakageHandler = (e) => {
    let tempMedArr = JSON.parse(JSON.stringify(medData));

    setMarkBreakage((prev) => setMarkBreakage(!prev));

    if (e.target.checked) {
      setDisableCheckbox(true);

      tempMedArr.map((row) => {
        ids.push(row.box_medicine_data_master_id);
      });

      axiosPrivate
        .put("/data_entry/to-breakage/", {
          checked: e.target.checked,
          ids: ids,
        })
        .then((res) => {
          if (res.status === 200) {
            tempMedArr.map((row) => {
              row.goods_type = "BREAKAGE";
            });

            toast.success("Updated record successfully", {
              theme: "colored",
              position: "top-right",
              autoClose: 500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((res) => {
          toast.error("Something went wrong!", {
            theme: "colored",
            position: "top-right",
            autoClose: 500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .finally(() => {
          setDisableCheckbox(false);
        });

      setMedData(tempMedArr);
    } else if (!e.target.checked) {
      const goodsTypeArr = [];
      const resData = rowData.filter(
        (row) =>
          row.goods_type === "SELLABLE" || row.goods_type === "SHORT EXPIRY"
      );

      resData.map((row) => {
        goodsTypeArr.push(row.goods_type);
      });

      setDisableCheckbox(true);

      axiosPrivate
        .put("/data_entry/to-breakage/", {
          checked: e.target.checked,
          ids: ids,
          status_arr: goodsTypeArr,
        })
        .then((res) => {
          if (res.status === 200) {
            tempMedArr.map((row, idx) => {
              row.goods_type = resData[idx]["goods_type"];
            });

            toast.success("Updated record successfully", {
              theme: "colored",
              position: "top-right",
              autoClose: 500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((res) => {
          toast.error("Something went wrong!", {
            theme: "colored",
            position: "top-right",
            autoClose: 500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .finally(() => {
          setDisableCheckbox(false);
        });
      ids.length = 0;

      setMedData(tempMedArr);
    }
  };


  const downloadExcel = async () => {
    const partyINFO = await axiosPrivate.get(
      `/data_entry/party-info/${boxId}/`
    );
    axiosPrivate(`/report/download-group-by/${boxId}?field_name=${tableType}`, {
      responseType: "blob",
    }).then((response) => {
      let date = new Date();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${partyINFO.data["party_code"]}_${
          partyINFO.data["lr_number"]
        }_${formatDate(date)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };


  const setDataHandler = (e, val) =>{
    if(val === null){
      return;
    } 

    let id = val['medicine_master_id']
    let bno = val["batch_number"];

    if (bno.length > 1) {
      const filteredData = batchData.filter(
        (med) =>
          med["medicine_master_id"] === id
      )[0];
      
      if (filteredData !== undefined) {
        setBatchNo(bno);
        setMaterialDesc(filteredData["description"]);
        setMaterialNo(filteredData["material"]);
        setMfgDate(filteredData["manufacture_date"]);
        setExpiryDate(filteredData["date_of_expiry"]);
        setMrp(filteredData["mrp"]);
        setDate(formatDate(filteredData["created_on"]));
        setExpiryStatus(filteredData["goods_type"]);
        quantityRef.current.focus();
      }
    }
  };


  const fetchDataHandler = (e, val) => {
    setBatchNo(val);
    if (val.length >= 1) {
      try {
        axiosPrivate
          .get(`/data_entry/batch_number/?search=${val}`)
          .then((res) => {
            setBatchData(res.data);
          });
      } catch (e) {
        console.error(e);
      }
    }
  }

  return (
    <div>
      <div
        className={
          tableType === "groupBy"
            ? "manual-entries-header-container"
            : "manual-entries-header-container-html-data"
        }
      >
        {tableType === "groupBy" && (
          <div className="manual-entries-header-section">
            {/*<p className="manual-entries-header-name">Recent Entries</p>*/}
            <input
              placeholder="Search By Batch No"
              className="manual-entries-header-input"
              type="text"
              value={searched}
              onChange={searchTableHandler}
            />
          </div>
        )}

        <div
          className={
            tableType === "groupBy"
              ? "manual-entries-select-section"
              : "manual-entries-select-container-html-table"
          }
        >
          <select
            onChange={changeTableHandler}
            className="manual-entries-select-container"
            disabled={isLoading}
          >
            <option value="groupBy">---Group By----</option>
            <option value="medicine_master__batch_number">
              Group by Batch Number
            </option>
            <option value="medicine_master__description">
              Group by Medicine Name
            </option>
          </select>
        </div>

        {tableType === "groupBy" && (
          <div className="manual-entries-medicine-type-select-section">
            <select
              className="manual-entries-select-container"
              onChange={sortMedicineHandler}
              disabled={isLoading}
            >
              <option value="all">All Medicines</option>
              <option value="expired">Expired Medicines</option>
              <option value="sellable">Sellable Medicines</option>
            </select>
          </div>
        )}

        {/* {medicineType === "sellable" && tableType === "groupBy" && (
          <div
            style={{ flexBasis: "2%" }}
            className="manual-entries-select-section"
          >
            <input onChange={(e) => markBreakageHandler(e)} type="checkbox" />
          </div>
        )}

        {medicineType === "sellable" && tableType === "groupBy" && (
          <div
            style={{ flexBasis: "20%" }}
            className="manual-entries-select-section"
          >
            <button
              className="manual-entries-download-html-data-btn"
              onClick={submitBreakageDataHandler}
              disabled={ids.length === 0}
            >
              Update
            </button>
          </div>
        )} */}

        {tableType !== "groupBy" && (
          <div className="manual-entries-download-html-data">
            <button
              className="manual-entries-download-html-data-btn"
              onClick={downloadExcel}
            >
              Download
            </button>
          </div>
        )}
        {tableType === "groupBy" && (
          <TablePagination
            rowsPerPageOptions={[50, 100, 200]}
            component="div"
            count={medData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>
      <div>
        <Paper
          style={{
            overflow: "hidden",
          }}
        >
          <Modal open={open} onClose={handleClose}>
            <div className="delete-modal">
              <div className="delete-modal-desc">
                <img alt="bin" className="delete-modal-img" src={bin} />
                <p className="delete-modal-desc-para dmdp-1">
                  You are about to delete a Record!
                </p>
                <p className="delete-modal-desc-para dmdp-2">
                  This will delete your record!
                </p>
                <p className="delete-modal-desc-para dmdp-3">Are you sure?</p>
              </div>
              <div className="delete-modal-btns">
                <button
                  onClick={handleClose}
                  className="delete-modal-btn dmb-1"
                  id="yes"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelteHandler}
                  className="delete-modal-btn dmb-2"
                  id="no"
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal>

          <TableContainer sx={{ maxHeight: "75vh" }}>
            {tableType === "groupBy" ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="manual-entries-table-head">
                  {/* <TableRow>
                    {columns.map((column, idx) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          width: column.minWidth,
                          fontSize: "0.75em",
                          padding: "0.75em",
                          textAlign: "center",
                          textTransform: "uppercase",
                          color: "white",
                          backgroundColor: "#000000",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow> */}
                  <TableRow>
                    {columns.map((column, idx) => {
                      if (idx === 6 && medicineType === "sellable") {
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              width: "8%",
                              fontSize: "0.75em",
                              padding: "0.75em",
                              textAlign: "center",
                              textTransform: "uppercase",
                              color: "white",
                              backgroundColor: "#000000",
                            }}
                          >
                            {column.label}{" "}
                            {medicineType === "sellable" &&
                              tableType === "groupBy" && (
                                <input
                                  style={{
                                    margin: "0",
                                    marginLeft: "4px",
                                    position: "relative",
                                    top: "2px",
                                  }}
                                  onChange={(e) => markBreakageHandler(e)}
                                  type="checkbox"
                                  checked={markBreakage}
                                  disabled={disableCheckbox}
                                />
                              )}
                          </TableCell>
                        );
                      } else {
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              width: column.minWidth,
                              fontSize: "0.75em",
                              padding: "0.75em",
                              textAlign: "center",
                              textTransform: "uppercase",
                              color: "white",
                              backgroundColor: "#000000",
                            }}
                          >
                            {column.label}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {medData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.box_medicine_data_master_id}>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <span>
                              <Autocomplete
                                // key={resetVal}
                                inputValue={batchNo}
                                disablePortal
                                clearOnBlur={false}
                                options={batchData}
                                clearOnEscape={true}
                                className="enter-details-input-autocomplete enter-details-batch-input"
                                sx={{
                                  width: "14vw",
                                  textTransform: "uppercase",
                                  "& .css-1krl8tb-MuiFormControl-root-MuiTextField-root": {
                                    height: "1.75em",
                                  },
                                  "& .MuiAutocomplete-hasPopupIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root":
                                    {
                                      height: "23.63px",
                                    },
                                  "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                    fontWeight: "600",
                                    top: "-8px",
                                    fontSize: "0.25em",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    height: "1.50em",
                                  },
                                  "& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator":
                                    {
                                      display: "none",
                                    },
                                  "& .MuiAutocomplete-input": {
                                    position: "absolute",
                                    width: "80% !important",
                                    fontSize: ".75rem",
                                  },
                                  '&[data-focus="false"]': {
                                    backgroundColor: "transparent",
                                    borderColor: "transparent",
                                  },
                                  '&[aria-selected="false"]': {
                                    borderColor: "transparent",
                                  },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                }}
                                getOptionLabel={(option) => option.batch_number}
                                renderOption={(props, batchData) => (
                                  <Box
                                    component="li"
                                    sx={{
                                      "& > img": { mr: 2, flexShrink: 0 },
                                  }}
                                    {...props}
                                  >
                                    {batchData["batch_number"]} | {batchData["description"]} | {batchData['date_of_expiry']}
                                  </Box>
                                )}
                                onChange={(event, value) => setDataHandler(event, value)}
                                onInputChange={(e, val) => fetchDataHandler(e, val)}
                                renderInput={(params) => <TextField sx={{
                                  "& .MuiOutlinedInput-input": {
                                    width: "3rem"
                                  }
                                }} {...params} label="" />}
                              />
                            </span>
                          ) : (
                            <div>{row.medicine_master__batch_number}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                ref={materialDescRef}
                                value={materialDesc}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__description}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={materialNoRef}
                                value={materialNo}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__material}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                type="number"
                                step="any"
                                style={{
                                  width: "100%",
                                }}
                                className="manualentry-input manualentry-edit-input"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                                ref={quantityRef}
                              />
                            </div>
                          ) : (
                            <div>{row.quantity}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={mrpRef}
                                value={mrp}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__mrp}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={expiryStatusRef}
                                value={expiryStatus}
                              />
                            </div>
                          ) : (
                            <div>{row.goods_type}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <input
                              type="checkbox"
                              onChange={checkBoxHandler}
                              ref={checkedRef}
                            />
                          ) : (
                            <input
                              type="checkbox"
                              onChange={
                                medicineType === "sellable"
                                  ? (e) =>
                                      toggleBreakageHandler(
                                        e,
                                        row.box_medicine_data_master_id
                                      )
                                  : () => {
                                      return;
                                    }
                              }
                              // disabled={
                              //   medicineType === "sellable" && !disableCheckbox
                              //     ? false
                              //     : true
                              // }
                              className="manual-entry-disabled-input"
                              checked={row.goods_type === "BREAKAGE" && true}
                              style={{
                                color: row.goods_type === "BREAKAGE" && "blue",
                              }}
                            />
                          )}
                        </TableCell>
                        {/* <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                ref={divRef}
                                style={{
                                  width: "100%",
                                }}
                                value={div}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__div}</div>
                          )}
                        </TableCell> */}
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={mfgDateRef}
                                value={mfgDate}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__manufacture_date}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={expiryDateRef}
                                value={expiryDate}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__date_of_expiry}</div>
                          )}
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={dateRef}
                                value={date}
                              />
                            </div>
                          ) : (
                            <div>{formatDate(row.created_on)}</div>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            ) : (
              <div id="group_by_table_container"></div>
            )}
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
};

export default ManualEntryTable;
